<script lang="ts">
  import {onMount} from 'svelte';
  import {
    accessLink,
    EmbeddedFlowState,
    viewState,
  } from 'Store/InvestorFlowStore';

  const handleTokenGenerated = () => {
    viewState.set(EmbeddedFlowState.EMBEDDED_CHECKOUT_FLOW);
  };

  const openPopup = () => {
    const popupUrl = new URL($accessLink);
    popupUrl?.searchParams?.set('isEmbeddedWebComponent', 'true');

    window.open(popupUrl, 'Popup', 'position=center,width=1100,height=850');
  };

  onMount(() => {
    openPopup();
  });
</script>

<svelte:window on:tokenGenerated={handleTokenGenerated} />

<div class="embed-flow" data-testid="embed-container">
  <h1>Please login in popup</h1>
</div>

<style>
  .embed-flow {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-top: 20rem;
  }
</style>
